// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__Xwtzb","header":"PatientBlock_header__CZw4S","label":"PatientBlock_label__11yic","option":"PatientBlock_option__15o1L"};